import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarousel from '@segment/templates/LogoCarousel'

const LogoCarouselComponent = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="noCopy">
        <Section.Contents>
          <LogoCarousel />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 10px;
    padding-bottom: 0;

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 40px;
    }
  }
`

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default LogoCarouselComponent
